import React from 'react'
import { getHexColor, OneColorIconProps } from '@/atoms/utils'

export const LinkedInLettersIcon: React.FC<OneColorIconProps> = ({ color = 'gray-100', size = 24 }) => {
  const c = getHexColor(color)

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.54165 23.6667V8.05891H0.697896V23.6667H5.54165ZM3.09373 5.97091C4.65623 5.97091 5.90623 4.66592 5.90623 3.09992C5.90623 1.58612 4.65623 0.333328 3.09373 0.333328C1.58331 0.333328 0.333313 1.58612 0.333313 3.09992C0.333313 4.66592 1.58331 5.97091 3.09373 5.97091ZM23.6146 23.6667H23.6666V15.1059C23.6666 10.9299 22.7291 7.69351 17.8333 7.69351C15.4896 7.69351 13.9271 8.9985 13.25 10.1991H13.1979V8.05891H8.56248V23.6667H13.4062V15.9411C13.4062 13.9053 13.7708 11.9739 16.2708 11.9739C18.7708 11.9739 18.8229 14.2707 18.8229 16.0977V23.6667H23.6146Z"
        fill={c}
      />
    </svg>
  )
}
